// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --cb-primary-color: #1953ff;
  --cb-primary-color-hover: rgba(25, 83, 255, 0.75);
  --cb-primary-color-disabled: #dfdfe0;
  --cb-button-text-primary-color: #fff;
  --cb-text-primary-color: #000000;
  --cb-text-secondary-color: #6e6d6d;
  --cb-header-text-color: #000000;
  --cb-error-popup-text-color: #4b5563;
  --cb-script-text-color: #000000;
  --cb-input-text-color: #000000;
  --cb-white: #ffffff;
  --cb-dark: #000000;
  --cb-border-color: rgb(212 212 212 / 60%);
  --cb-secondary-link-color: #59acff;
  --cb-box-color: #f5f5f5;
  --cb-box-color-hover: #f5f5f5;
  --cb-error-text-color: #fa5f55;
  --cb-otp-disabled-color: #fbfbfb;
  --cb-divider-line-color: rgba(0, 0, 0, 0.3);
  --cb-input-disabled-color: #dfdfe0;
  --cb-error-popup-background-color: #e9e9e9;
  --cb-passkey-list-badge-color: #359aff;
  --cb-passkey-list-badge-background-color: #e5f1ff;
  --cb-passkey-list-description-text-color: #8d8d8d;
  --cb-passkey-list-border-color: rgb(212 212 212 / 60%);
  --cb-passkey-list-border-hover-color: #848484;
  --cb-primary-font: 'Space Grotesk', sans-serif;
  --cb-secondary-font: 'Inter', sans-serif;
  --cb-font-weight-bold: 700;
  --cb-font-weight-normal: 400;
  --cb-base-font-size: 0.65rem;
  --cb-border-radius-lg: 1.125rem;
  --cb-border-radius-sm: 0.5rem;
  --cb-error-font-size: 0.8rem;
  --cb-input-field-height: 2.2rem;
  --cb-container-full-width: 100%;
  --cb-container-wide-width: 90%;
  --cb-container-standard-width: 83%;
  --cb-container-medium-width: 75%;
}

.cb-dark {
  --cb-header-text-color: #ffffff;
  --cb-text-primary-color: #ffffff;
  --cb-text-secondary-color: #a1a1a1;
  --cb-error-popup-text-color: #ffffff;
  --cb-script-text-color: #a1a1a1;
  --cb-box-color: #1f1f1f;
  --cb-box-color-hover: #3b3b3b;
  --cb-secondary-link-color: #59acff;
  --cb-dark: #ffffff;
  --cb-white: #000000;
  --cb-otp-disabled-color: #0e0e0e;
  --cb-border-color: rgb(132 140 166 / 65%);
  --cb-primary-color-hover: rgba(25, 83, 255, 0.5);
  --cb-primary-color-disabled: #6f7486;
  --cb-divider-line-color: rgba(255, 255, 255, 0.4);
  --cb-input-disabled-color: #6f7486;
  --cb-input-text-color: #ffffff;
  --cb-error-popup-background-color: #5b5b5b;
  --cb-passkey-list-badge-color: #7cb6fd;
  --cb-passkey-list-badge-background-color: #092045;
  --cb-passkey-list-description-text-color: #d9d9d9;
  --cb-passkey-list-border-color: rgb(132 140 166 / 65%);
  --cb-passkey-list-border-hover-color: #ffffff;
}

@media screen and (max-width: 481px) {
  :root {
    --cb-container-wide-width: 97%;
    --cb-container-standard-width: 94%;
    --cb-container-medium-width: 85%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,oCAAoC;EACpC,oCAAoC;EACpC,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,2CAA2C;EAC3C,kCAAkC;EAClC,0CAA0C;EAC1C,sCAAsC;EACtC,iDAAiD;EACjD,iDAAiD;EACjD,sDAAsD;EACtD,6CAA6C;EAC7C,8CAA8C;EAC9C,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,yCAAyC;EACzC,gDAAgD;EAChD,oCAAoC;EACpC,iDAAiD;EACjD,kCAAkC;EAClC,8BAA8B;EAC9B,0CAA0C;EAC1C,sCAAsC;EACtC,iDAAiD;EACjD,iDAAiD;EACjD,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;EACE;IACE,8BAA8B;IAC9B,kCAAkC;IAClC,gCAAgC;EAClC;AACF","sourcesContent":[":root {\n  --cb-primary-color: #1953ff;\n  --cb-primary-color-hover: rgba(25, 83, 255, 0.75);\n  --cb-primary-color-disabled: #dfdfe0;\n  --cb-button-text-primary-color: #fff;\n  --cb-text-primary-color: #000000;\n  --cb-text-secondary-color: #6e6d6d;\n  --cb-header-text-color: #000000;\n  --cb-error-popup-text-color: #4b5563;\n  --cb-script-text-color: #000000;\n  --cb-input-text-color: #000000;\n  --cb-white: #ffffff;\n  --cb-dark: #000000;\n  --cb-border-color: rgb(212 212 212 / 60%);\n  --cb-secondary-link-color: #59acff;\n  --cb-box-color: #f5f5f5;\n  --cb-box-color-hover: #f5f5f5;\n  --cb-error-text-color: #fa5f55;\n  --cb-otp-disabled-color: #fbfbfb;\n  --cb-divider-line-color: rgba(0, 0, 0, 0.3);\n  --cb-input-disabled-color: #dfdfe0;\n  --cb-error-popup-background-color: #e9e9e9;\n  --cb-passkey-list-badge-color: #359aff;\n  --cb-passkey-list-badge-background-color: #e5f1ff;\n  --cb-passkey-list-description-text-color: #8d8d8d;\n  --cb-passkey-list-border-color: rgb(212 212 212 / 60%);\n  --cb-passkey-list-border-hover-color: #848484;\n  --cb-primary-font: 'Space Grotesk', sans-serif;\n  --cb-secondary-font: 'Inter', sans-serif;\n  --cb-font-weight-bold: 700;\n  --cb-font-weight-normal: 400;\n  --cb-base-font-size: 0.65rem;\n  --cb-border-radius-lg: 1.125rem;\n  --cb-border-radius-sm: 0.5rem;\n  --cb-error-font-size: 0.8rem;\n  --cb-input-field-height: 2.2rem;\n  --cb-container-full-width: 100%;\n  --cb-container-wide-width: 90%;\n  --cb-container-standard-width: 83%;\n  --cb-container-medium-width: 75%;\n}\n\n.cb-dark {\n  --cb-header-text-color: #ffffff;\n  --cb-text-primary-color: #ffffff;\n  --cb-text-secondary-color: #a1a1a1;\n  --cb-error-popup-text-color: #ffffff;\n  --cb-script-text-color: #a1a1a1;\n  --cb-box-color: #1f1f1f;\n  --cb-box-color-hover: #3b3b3b;\n  --cb-secondary-link-color: #59acff;\n  --cb-dark: #ffffff;\n  --cb-white: #000000;\n  --cb-otp-disabled-color: #0e0e0e;\n  --cb-border-color: rgb(132 140 166 / 65%);\n  --cb-primary-color-hover: rgba(25, 83, 255, 0.5);\n  --cb-primary-color-disabled: #6f7486;\n  --cb-divider-line-color: rgba(255, 255, 255, 0.4);\n  --cb-input-disabled-color: #6f7486;\n  --cb-input-text-color: #ffffff;\n  --cb-error-popup-background-color: #5b5b5b;\n  --cb-passkey-list-badge-color: #7cb6fd;\n  --cb-passkey-list-badge-background-color: #092045;\n  --cb-passkey-list-description-text-color: #d9d9d9;\n  --cb-passkey-list-border-color: rgb(132 140 166 / 65%);\n  --cb-passkey-list-border-hover-color: #ffffff;\n}\n\n@media screen and (max-width: 481px) {\n  :root {\n    --cb-container-wide-width: 97%;\n    --cb-container-standard-width: 94%;\n    --cb-container-medium-width: 85%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
